export default class CampaignService {
  /** @ngInject **/
  constructor(
    $http,
    $q,
    accountsService,
    ngAuthSettings,
    promiseCacheService
  ) {
    this.$http = $http;
    this.$q = $q;
    this.accountsService = accountsService;
    this.ngAuthSettings = ngAuthSettings;
    this.promiseCacheService = promiseCacheService;

    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  getCampaigns(accountId, getStats) {
    if (this.#canViewCampaigns()) {
      return this.#getCampaignsFromCachedPromise(accountId, getStats);
    } else {
      var deferred = this.$q.defer();
      deferred.resolve({
        data: {
          campaigns: []
        }
      });
      return deferred.promise;
    }
  }

  getCampaignsBasic(accountId) {
    if (this.#canViewCampaigns()) {
      return this.#getCampaignsBasicFromCachedPromise(accountId);
    } else {
      var deferred = this.$q.defer();
      deferred.resolve({
        data: {
          campaigns: []
        }
      });
      return deferred.promise;
    }
  }

  getCompletedCampaigns(accountId) {
    return this.getCampaigns(accountId).then((response) => {
      var campaigns = _.filter(response.data.campaigns, (campaign) => {
        return campaign.completed;
      });
      return campaigns;
    });
  }

  getBasicCompletedCampaigns(accountId) {
    return this.getCampaignsBasic(accountId).then((response) => {
      var campaigns = _.filter(response.data.campaigns, (campaign) => {
        return campaign.completed;
      });
      return campaigns;
    });
  }

  async createBasicCompletedCampaign(accountId, campaign) {
    const request = {
      name: campaign.name,
      countryCode: campaign.countryCode,
      numberDisplayFormat: '(nnn) nnn-nnnn',
      recordSetting: {
        record: true,
        recordFromAnswer: true,
        trimSilence: true
      },
      deDupeSettings: {
        routeToOriginal: false,
        routeToDifferent: false
      }
    };
    const url = this.serviceBaseUri + accountId + '/campaigns';
    const response = await this.$http.post(url, request);
    this.#cleanAccountCampaignsCache(accountId);
    return response;
  }

  #canViewCampaigns() {
    return !this.accountsService.isBuyer();
  }

  #getCampaignsFromCachedPromise(accountId, getStats) {
    //blocks from same page load calling the server multiple
    //times
    var key = this.#getCacheKey(accountId, getStats);
    var url = this.serviceBaseUri + accountId + '/campaigns' + (getStats ? '?includestats=true' : '');
    return this.promiseCacheService.getCallWithCachedPromise(key, url, 5);
  }

  #getCampaignsBasicFromCachedPromise(accountId, getStats) {
    //blocks from same page load calling the server multiple
    //times
    var key = this.#getBasicCampaignCacheKey(accountId, getStats);
    var url = this.serviceBaseUri + accountId + '/campaigns/ui';
    return this.promiseCacheService.getCallWithCachedPromise(key, url, 5);
  }

  #getCacheKey(accountId, getStats) {
    return 'campaignGetPromise' + accountId + (getStats ? 'includestats' : '');
  }

  #getBasicCampaignCacheKey(accountId) {
    return 'campaignBasicGetPromise' + accountId;
  }

  #cleanAccountCampaignsCache(accountId) {
    // We have to clean all variations of account-wise cache of the campaigns list.
    let key = this.#getCacheKey(accountId, false);
    this.promiseCacheService.clean(key);

    key = this.#getCacheKey(accountId, true);
    this.promiseCacheService.clean(key);
  }

}